import { ChangeDetectorRef, Component, Input, NgZone, OnInit, afterNextRender } from '@angular/core';

import { GoToTopAnimation } from './go-to-top.animation';

import { faChevronUp } from '@fortawesome/free-solid-svg-icons';

/**
 * Element that shows after the user scroll something to the botton. When the
 * user interacts backs to the top. This should be in the AppComponent.
 */
@Component({
    selector: 'app-go-to-top',
    templateUrl: './go-to-top.component.html',
    styleUrls: ['./go-to-top.component.scss'],
    animations: GoToTopAnimation,
    standalone: false
})
export class GoToTopComponent {
  @Input() containerTarget: string;
  /**
   * Show or hide the component.
   */
  display = false;

  /**
   * How much the user should scroll to see the element.
   */
  topPosToStartShowing = 750;

  /**
   * @deprecated Don`t found any use.
   */
  isBrowser = false;

  readonly faChevronUp = faChevronUp;
  constructor(
    private zone: NgZone,
    private cd: ChangeDetectorRef
  ) {
    afterNextRender(() => {
      this.zone.runOutsideAngular(() => {
        this.scrollContainer.addEventListener(
          'scroll',
          elem => {
            const shouldShow = this.getYPosition(elem) >= this.topPosToStartShowing;

            if (shouldShow !== this.display) {
              this.display = shouldShow;
              this.cd.detectChanges();
            }
          },
          { passive: true }
        );
      });
    });
  }

  /**
   *  Gets the Y position of the scroll.
   *  @param e The scroll event.
   * @return The Y position of the scroll.
   * */
  private getYPosition(e) {
    const el = document.querySelector(this.containerTarget);

    if (el) {
      return (e && (e.target as HTMLElement)?.scrollTop) || el.scrollTop || 0;
    }
    return e?.target?.scrollingElement?.scrollTop || 0;
  }

  /**
   * Scolls to the top page.
   */
  gotoTop() {
    this.scrollContainer.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  /**
   * Gets the scroll container.
   * If the containerTarget is not set, it will return the window.
   */
  private get scrollContainer(): Element | Window {
    return document.querySelector(this.containerTarget) || window;
  }
}
